export type BasicQuerySearch = {
    limit?: number;
    offset?: number;
    /**
     * Search can be either include `name` field or `id`
     */
    search?: string;
    ordering?: "name" | "created_date" | "id",
    /**
     * //TODO: is the token always needed to be sent? maybe store it in a global variable from there and acces 
     */
    token?: string
    fields?: string
}

export type QueryResponse<T> = {
    count: number;
    next: string | null;
    previous: string | null;
    results: T[];
}

export const defaultQuery: BasicQuerySearch = {
    limit: 10,
    ordering: "name"
}


// type Key<K extends string & keyof BasicQuerySearch> = `${K}=${Exclude<BasicQuerySearch[K], undefined>}`
export function generateQueryString<T extends BasicQuerySearch>(obj: T) {
    const queryString = Object.entries(obj).map(([k, v]) => `${k}=${v}`).join("&");
    return queryString ? `?${queryString}` : ''
}

export async function fetchAndParse<T>(input: RequestInfo, init?: RequestInit): Promise<T> {
    const response = await fetch(input, init)
    if (response.status !== 200) {
        let json: string | null = null;
        try {
            json = await response.json();
        } catch (e) {

        }
        // eslint-disable-next-line no-throw-literal
        throw {
            status: response.status,
            statusText: response.statusText,
            response,
            json,
        };
    }
    const data = await response.json();
    return data as T;
}

